import { apiRequest } from './api';

/**
 * Game-wide settings. Admin only — the router refuses everyone else.
 *
 * Separate from `services/sprites.js`, which carries `spriteSubmissionsOpen`
 * next to the page that governs it. These are the settings that change how the
 * WORLD behaves rather than who may upload art.
 */

/** @returns {Promise<{coinsEnabled: boolean}>} */
export const getSettings = (token) => apiRequest('/api/settings', { token });

/**
 * Turn money on or off, everywhere, immediately.
 *
 * Takes effect in rooms people are already standing in — the server pushes a
 * fresh coin list rather than waiting for them to rejoin.
 */
export const setCoinsEnabled = (token, coinsEnabled) => apiRequest(
  '/api/settings',
  { method: 'PUT', token, body: { coinsEnabled } },
);

export default getSettings;
